import styled, { DefaultTheme } from 'styled-components';

export const CountItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  width: 100%;
`;

export const CountValueWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  width: 100%;
`;

export const CountItemTitle = styled.div`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const CountItemValue = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const StateColorSquare = styled.div<{ color: keyof DefaultTheme['colors'] }>`
  width: 12px;
  height: 12px;
  aspect-ratio: 1/1;
  border-radius: 2px;
  background: ${({ theme, color }) => theme.colors[color]};
`;
